import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CacheService, CacheKey } from '../../../services/cache-service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '../../utility/dialog/dialog-service';
import { ModalType } from '../../utility/dialog-template/dialog-template.component';

@Component({
  selector: 'app-cache',
  templateUrl: './cache-management.component.html',
  styleUrls: ['./cache-management.component.css'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class CacheManagementComponent implements OnInit {
  displayedColumns: string[] = ['key', 'valueId', 'actions'];
  dataSource = new MatTableDataSource<CacheKey>();
  selection = new Set<CacheKey>();
  selectedValue: any = null;
  selectedKey: string = '';
  loading = false;
  viewLoading = false;


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private cacheService: CacheService,
    private snackBar: MatSnackBar,
    private dialogService: DialogService
  ) { }

 
  ngOnInit(): void {
    this.fetchCacheKeys();
  }

  ngAfterViewChecked() {
    if (this.paginator && this.dataSource.paginator !== this.paginator) {
      this.dataSource.paginator = this.paginator;
    }

    if (this.sort && this.dataSource.sort !== this.sort) {
      this.dataSource.sort = this.sort;
    }
  }


  fetchCacheKeys(): void {
    this.loading = true;
    this.cacheService.getCacheKeys().subscribe({
      next: (res) => {
        this.dataSource.data = res;
        this.loading = false; 
      },
      error: (err) => {
        console.error('Failed to load cache keys:', err);
        this.snackBar.open('Failed to load cache keys', 'Close', { duration: 3000 });
        this.loading = false;
      }
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

 toggleSelection(row: CacheKey): void {
    if (this.selection.has(row)) {
      this.selection.delete(row);
    } else {
      this.selection.add(row);
    }
  }

  viewKey(key: string): void {
    this.viewLoading = true;
    this.selectedKey = key;
    this.selectedValue = null; 

    this.cacheService.getCacheValue(key).subscribe({
      next: (value) => {
        this.selectedValue = value;
        this.viewLoading = false;
      },
      error: () => {
        this.snackBar.open(`Failed to load value for key: ${key}`, 'Close', { duration: 3000 });
        this.viewLoading = false;
      }
    });
  }


  deleteKey(key: string): void {
    this.dialogService.openModal(
      'Confirm Deletion',
      `Are you sure you want to delete the key: "${key}"?`,
      ModalType.QUESTION,
      () => {
        this.cacheService.deleteCacheKey(key).subscribe({
          next: () => {
            this.snackBar.open('Key deleted', 'Close', { duration: 2000 });
            this.fetchCacheKeys();
          },
          error: () => {
            this.snackBar.open(`Failed to delete key: ${key}`, 'Close', { duration: 3000 });
          }
        });
      },
      () => {
        this.snackBar.open('Deletion cancelled', 'Close', { duration: 2000 });
      }
    );
  }
  closeView(): void {
    this.selectedValue = null;
    this.selectedKey = '';
  }

  clearAllCache(): void {
    this.dialogService.openModal(
      'Confirm Full Cache Clear',
      'This will remove ALL cache entries (Redis). Continue?',
      ModalType.WARN,
      () => {
        this.loading = true;

        this.cacheService.clearAllCache().subscribe({
          next: () => {
            this.snackBar.open('Cache cleared successfully', 'Close', { duration: 3000 });

            this.selectedKey = '';
            this.selectedValue = null;

            this.fetchCacheKeys();
            this.loading = false;
          },
          error: () => {
            this.snackBar.open('Failed to clear cache', 'Close', { duration: 3000 });
            this.loading = false;
          }
        });
      },
      () => {
        this.snackBar.open('Cancelled', 'Close', { duration: 2000 });
      }
    );
  }

}
